import {
  administrative,
  declareFieldMeanings,
  identity,
  means,
} from '../../../src/issues/field-meanings';

/** What each recorded-document detail means to an owner. */
export const fieldMeanings = declareFieldMeanings({
  sources: ['recorder'],
  declarations: [
    identity('documentNumber', 'Document number', 'Old document number'),
    administrative('Book type', 'Book number', 'Page count'),
    means('date', 'the recording date', ['documentDate', 'Document date']),
    means('detail', 'the document type', ['titles', 'Title(s)'], {
      matters: 'changes what kind of document the county shows recorded',
    }),
    means('detail', 'the parties named on the document', ['names', 'Indexed parties'], {
      matters: 'changes who the document names',
    }),
  ],
});
